var { npmPkg, accent } = require('../common.js')
const pkg = require('../../package.json')

function version(yargs) {
	console.log(accent(pkg.version))
}

module.exports = version


// WEBPACK FOOTER //
// ./src/commands/version.js